import React from 'react';

import { ChartContainer, PieChart } from '@/components/organisms/Aggregates';
import { CmCard, CmHeading, CmText } from '@/components/uiParts';
import { PieDatum } from '@/domain/models/Chart';

interface Props {
  displayData: PieDatum[];
  title:
    | '店舗ごと売上'
    | '商品ごと売上'
    | 'ブランド別比率'
    | '配達方法別比率'
    | 'デリバリーサービス別比率'
    | '店舗別比率'
    | '拠点別比率';
  isDisableLegends?: boolean;
  isEmpty?: boolean;
}

export const SalesRatio: React.FC<Props> = ({
  displayData,
  title,
  isDisableLegends,
  isEmpty,
}) => {
  return (
    <CmCard>
      <CmHeading as="h2">{title}</CmHeading>
      <ChartContainer mt={5} height="250px" width="auto">
        {!isEmpty ? (
          <PieChart
            data={displayData}
            format="currency"
            isDisableLegends={isDisableLegends}
          />
        ) : (
          <CmText>対象のデータがありません</CmText>
        )}
      </ChartContainer>
    </CmCard>
  );
};
